import React, { useContext } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { ContentLayoutContext } from "../../contexts/ContentLayoutContext";
import { ActualLangContext } from "../../contexts/ActualLangContext";
import { homeEs } from "../../config/home/home";
import { awards as awardsTextEn } from "../../config/home/textPage";

const Awards = () => {
  const { awardsContent } = useContext(ContentLayoutContext);
  const { actualLang } = useContext(ActualLangContext);
  
  // Usar configuración local para los textos principales
  const isEnglish = actualLang === "en";
  const localTexts = isEnglish ? awardsTextEn : homeEs.awards;
  
  return (
    <Container fluid id="houstonAwardsContainer">
      <div id="awardsBackgroundGrey"></div>
      <Container id="houstonAwards">
        <Row className="awards">
          <Col lg={4} className="awardsContent">
            <h3>{localTexts.title}</h3>
            <p>{localTexts.description}</p>
            <Button variant="primary" href={isEnglish ? "/en-en/awards" : "/es-es/reconocimientos"}>
              {localTexts.button}
            </Button>
          </Col>
          <Col lg="6">
            <Row>
              {awardsContent?.award?.map((award, idx) => (
                <Col lg={4} key={idx} className="award">
                  <Image src={award.image.data.attributes.url} />
                  <p className="awardText">{award.description}</p>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Awards;
